import React, { useState, useEffect } from 'react';
import { FileText } from 'lucide-react';
import { usePageHeader } from '../../contexts/PageHeaderContext';
import EmployeeP11 from '../employee/EmployeeP11';
import EmployeeP45 from '../employee/EmployeeP45';
import EmployeeP60 from '../employee/EmployeeP60';

const PayrollDocuments = () => {
  const { setHeader } = usePageHeader();
  const [activeTab, setActiveTab] = useState('p60');

  useEffect(() => {
    setHeader({
      icon: FileText,
      title: 'Payroll Documents',
      subtitle: 'View and download your payroll documents.',
    });
    return () => setHeader({ icon: null, title: '', subtitle: '' });
  }, [setHeader]);

  const tabs = [
    { id: 'p60', label: 'P60 Document', icon: FileText },
    { id: 'p11', label: 'P11 Document', icon: FileText },
    { id: 'p45', label: 'P45 Document', icon: FileText },
  ];

  return (
    <div className="max-w-7xl mx-auto p-4 sm:p-6 lg:p-8">
      <div className="bg-white rounded-xl shadow-lg p-4 sm:p-6 lg:p-8">
        <div className="border-b border-gray-200">
          <nav
            className="-mb-px flex space-x-2 sm:space-x-4 overflow-x-auto"
            aria-label="Tabs"
          >
            {tabs.map((tab) => {
              const Icon = tab.icon;
              const isActive = activeTab === tab.id;
              return (
                <button
                  key={tab.id}
                  type="button"
                  onClick={() => setActiveTab(tab.id)}
                  className={`whitespace-nowrap py-2 sm:py-3 px-2 sm:px-4 border-b-2 text-xs sm:text-sm font-medium flex items-center gap-1.5 sm:gap-2 ${
                    isActive
                      ? "border-indigo-500 text-indigo-600"
                      : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                  }`}
                >
                  <Icon className="w-4 h-4" />
                  {tab.label}
                </button>
              );
            })}
          </nav>
        </div>

        {activeTab === "p11" && <EmployeeP11 hideHeader={true} />}
        {activeTab === "p45" && <EmployeeP45 hideHeader={true} />}
        {activeTab === "p60" && <EmployeeP60 hideHeader={true} />}
      </div>
    </div>
  );
};

export default PayrollDocuments;
